import { Admin } from '@models/Admin'
import { useAuth } from '@modules/auth/contexts/Auth'
import dayjs from 'dayjs'
import { useMemo } from 'react'

export const SayHello = (): string => {
  const { currentUser } = useAuth<Admin, {}>()

  const greetUser = useMemo(() => {
    const hour = dayjs().hour()

    let greeting = 'Good morning'
    if (hour >= 12 && hour < 18) {
      greeting = 'Good afternoon'
    } else if (hour >= 18) {
      greeting = 'Good evening'
    }

    return `${greeting} ${currentUser?.firstName}`
  }, [currentUser])
  return greetUser
}
